import { buildContractPath } from "./api/contract-client.js";

export const ORCHESTRATION_TIMEOUT_MS = 20000;

export function buildGetIncidentCellPath(eventId) {
  return buildContractPath("get__incidents_p_cell", { pathParams: [eventId] });
}

export function buildPostIncidentCellActivatePath(eventId) {
  return buildContractPath("post__incidents_p_cell_activate", { pathParams: [eventId] });
}

export function buildPostIncidentCellResolvePath(eventId) {
  return buildContractPath("post__incidents_p_cell_resolve", { pathParams: [eventId] });
}

export function buildGetIncidentClusterPath(eventId) {
  return buildContractPath("get__incidents_p_cluster", { pathParams: [eventId] });
}

export function buildPostIncidentClusterJoinPath(eventId) {
  return buildContractPath("post__incidents_p_cluster_join", { pathParams: [eventId] });
}

export function buildPostIncidentClusterLeavePath(eventId) {
  return buildContractPath("post__incidents_p_cluster_leave", { pathParams: [eventId] });
}

export function buildPostIncidentClusterReallocatePath(eventId) {
  return buildContractPath("post__incidents_p_cluster_reallocate", { pathParams: [eventId] });
}

export function buildPatchIncidentClusterPriorityPath(eventId) {
  return buildContractPath("patch__incidents_p_cluster_priority", { pathParams: [eventId] });
}

export function buildGetIncidentClusterAffinityPath(eventId) {
  return buildContractPath("get__incidents_p_cluster_affinity", { pathParams: [eventId] });
}

export function buildGetIncidentStigmergyPath(eventId) {
  return buildContractPath("get__incidents_p_stigmergy", { pathParams: [eventId] });
}

export function buildPostIncidentStigmergyPath(eventId) {
  return buildContractPath("post__incidents_p_stigmergy", { pathParams: [eventId] });
}

export function buildGetIncidentSwarmAuditPath(eventId) {
  return buildContractPath("get__incidents_p_swarm-audit", { pathParams: [eventId] });
}

export function buildGetActuatorResourcesPath() {
  return buildContractPath("get__actuators_resources");
}

export function buildPostActuatorSelectPath() {
  return buildContractPath("post__actuators_resources_select");
}
